import moment from 'moment';
import { IServiceClient } from 'src/interfaces/serviceClient';
import type { ServiceClientRowDisplayValues } from './types';
import { getVehicleLabel } from './getVehicleLabel';

/**
 * Extracts display values for a service client table row (store, agent, vehicle, createdAt).
 *
 * @param row - Service client (lead with type service)
 * @returns Object with display strings for each column, or null where not present
 */
export function getServiceClientRowDisplayValues(
    row: IServiceClient
): ServiceClientRowDisplayValues {
    const storeName =
        typeof row.store === 'object' && row.store?.name
            ? row.store.name
            : null;
    const agentName =
        typeof row.agent === 'object' && row.agent?.name
            ? row.agent.name
            : null;
    const vehicleLabel = getVehicleLabel(row);
    const createdAtFormatted =
        row.createdAt != null
            ? moment(row.createdAt).format('DD MMMM YYYY') +
              ' ' +
              moment(row.createdAt).format('hh:mm a')
            : null;

    return {
        storeName,
        agentName,
        vehicleLabel,
        createdAtFormatted,
    };
}
